/* tslint:disable */
import { createHashHistory } from 'history';

export default createHashHistory();
